export default {
  headerContent: {
    title: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası Teklifi',
    slogan: "Tamamlayıcı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TAMAMLAYICI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası',
    description: {
      title: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası Nedir? ',
      content: [
        'Tamamlayıcı sağlık sigortası sizi beklenmedik, yüksek tıbbi maliyetlerden korur. Tamamlayıcı sağlık sigortası sosyal güvencesi bulunan bireylerin özel hastanelerde tedavi hizmeti almanızı sağlar.',
        'Sağlık sigortası poliçeniz, sizinle sigorta şirketiniz arasındaki bir anlaşmadır.',
        'Sompo Sigorta tamamlayıcı sağlık sigortası SGK ile anlaşmalı özel hastaneler kaza veya hastalık sonucu alınması gereken tedavi hizmeti sonucunda oluşan maddi giderlere karşı koruma sağlamaktadır.',
        'Önleyici hizmetler, hastalığı tespit edebilir ve hastalıkları veya diğer sağlık sorunlarını önlemeye yardımcı olabilir. İhtiyaç duyduğunuz önleyici hizmet türleri cinsiyetinize, yaşınıza, tıbbi geçmişinize ve aile geçmişinize bağlıdır.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Tamamlayıcı sağlık sigortası teminatları yatarak, ayakta ve doğum olmak üzere 3’e ayrılmaktadır. ',
          subList: null
        },
        {
          paragraph:
            '<strong><em><u>Yatarak Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Yatarak Tedavi Teminatları;',
            'Cerrahi ve dâhili yatışlar',
            'Yoğun bakım',
            'Kemoterapi',
            'Radyoterapi',
            'Diyaliz',
            'Küçük müdahale',
            'Koroner anjiyografi',
            'Standart tek kişilik özel oda, yemek ve refakatçi giderleri',
            'Ameliyat sonrası fizik tedavi',
            'Evde Bakım ',
            'Suni Uzuv ',
            'Yardımcı Tıbbi Malzeme'
          ]
        },
        {
          paragraph:
            '<strong><em><u>Ayakta Tedavi Teminatları;</u></em></strong>',
          subList: [
            'Doktor Muayene',
            'Laboratuvar',
            'Görüntüleme',
            'Modern Teşhis ( MR, Tomografi vb.)',
            'Fizik Tedavi'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Tamamlayıcı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Tamamlayıcı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo Sigorta Tamamlayıcı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
